export class Loader {
  constructor(container) {
    this.container = container;

    this.overlay = document.createElement('section');
    this.overlay.classList.add('loader');

    this.image = document.createElement('img');
    this.image.setAttribute('src', '/images/spinner.svg');
    this.overlay.appendChild(this.image);

    this.container.appendChild(this.overlay);
  }

  remove() {
    this.container.removeChild(this.overlay);
  }
}